// Centralized challenge scoring constants (V1)
export const CHALLENGE_SCORE_COLUMN_V1 = 'e1rm';
export const CHALLENGE_SCORE_LABEL_V1 = 'DUEL Standard';
export const CHALLENGE_SCORE_HELPER_V1 = 'Est. 1RM';

// Future exports for swapping scoring implementations can be added here.
